import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  integrations: null,
  mongoDbIntegrationData: null,
};

const integrationSlice = createSlice({
  name: "integration",
  initialState,
  reducers: {
    setIntegrations(state, action) {
      state.integrations = action.payload;
    },
    setMongoDbIntegrationData(state, action) {
      state.mongoDbIntegrationData = action.payload;
    },
  },
});

export const { setIntegrations, setMongoDbIntegrationData } =
  integrationSlice.actions;

export default integrationSlice.reducer;
